module.exports = __webpack_public_path__ + "static/media/cart_logo_tw.4eb46703.png";